import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import breakfast from './../assets/pdf/breakfast.pdf'

import event1 from './../assets/images/Events/halloween.jpeg'
import event2 from './../assets/images/Events/breakfast.jpeg'
import event3 from './../assets/images/Events/christmasPoster.jpeg'
import garden from './../assets/images/Backgrounds/garden.webp'

const EventSlider = () => {
  const slides = [
    {
      url: event3,
      title: 'Christmas Parties',
      description:
        'Get ready for a season of festive cheer with our incredible Christmas events! We have something for everyone, whether you want to hit the slopes or enjoy a delicious meal.\n\nVisit our Christmas Events page to book your unforgettable experience!',
      link: 'Christmas',
      buttonText: 'View Events',
    },
    {
      url: event1,
      title: 'Halloween Party',
      description:
        'Get ready for a night of NO FEAR, ALL CHEER! 🕷️🖤\n\nJoin us for an unforgettable Halloween night with:\n🎶 DJs spinning all night\n🍽️ Food available\n🍾 £5 tickets available through Skiddle\n⏰ 7PM - LATE\n🎭 Best Dressed competitions with some brilliant prizes!\n👠 Best Dressed Woman: Bottle of Prosecco\n💑 Best Dressed Couple: Sunday Lunch for 2\n🎩 Best Dressed Man: Three Pints\n\nSo get your costumes ready, grab your tickets and come celebrate Halloween with us!',
      link: 'https://www.skiddle.com/whats-on/Stourbridge/The-Fox-Inn-Stourton/The-Fox-Inn-Presents--Burrow-Halloween-Bash/42838033/',
      buttonText: 'Book Now',
    },
    {
      url: event2,
      title: 'We do Breakfast',
      description:
        'Our breakfast menu is served Tuesday to Sunday, 8 AM till 11 AM. Check out our menu and book now or just turn up!',
      link: breakfast,
      buttonText: 'View Menu',
      secondLink: 'https://www.opentable.co.uk/r/the-fox-inn-reservations-stourbridge?restref=161223&lang=en-GB&ot_source=Restaurant%20website',
      secondButtonText: 'Book Now'
    }
  ]

  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <div
      className="relative flex py-8 px-6 overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: `url(${garden})` }}
    >

      <div className="relative z-10 flex flex-col md:flex-row justify-center items-center gap-16 w-full mx-auto">
        {/* Swiper Slider */}
        <div className="w-[350px] md:w-[400px]">
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            loop={true}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
              delay: 12000,
              disableOnInteraction: false,
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            className="rounded-2xl shadow-xl"
          >
            {slides.map((slide, idx) => (
              <SwiperSlide key={idx}>
                <div
                  className="w-full aspect-[2/3] bg-center bg-cover rounded-2xl transition-transform duration-500 hover:scale-105"
                  style={{ backgroundImage: `url(${slide.url})` }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Text Content */}
        <div className="flex flex-col justify-center px-6 text-center md:text-left lg:w-[40%] text-black">
          <h3 className="text-5xl md:text-6xl font-bold drop-shadow-lg">
            {slides[activeIndex].title}
          </h3>
          <p className="mt-4 text-lg font-bold whitespace-pre-line">
            {slides[activeIndex].description}
          </p>
          <div className='space-x-6'>
            <a
                href={slides[activeIndex].link}
                rel="noopener noreferrer"
                target="_blank"
                className="mt-6 inline-block px-4 py-2 w-fit bg-gray-800 text-white text-base font-medium rounded-md shadow-md hover:bg-gray-600 transition-colors"
            >
                {slides[activeIndex].buttonText}
            </a>
            {slides[activeIndex].secondLink && (
              <a
                href={slides[activeIndex].secondLink}
                rel="noopener noreferrer"
                target="_blank"
                className="mt-6 inline-block px-4 py-2 w-fit bg-cyan-800 text-white text-base font-medium rounded-md shadow-md hover:bg-cyan-600 transition-colors"
              >
                {slides[activeIndex].secondButtonText}
              </a>
            )}
            {slides[activeIndex].thirdLink && (
              <a
                href={slides[activeIndex].thirdLink}
                rel="noopener noreferrer"
                target="_blank"
                className="mt-6 inline-block px-4 py-2 w-fit bg-sky-800 text-white text-base font-medium rounded-md shadow-md hover:bg-sky-600 transition-colors"
              >
                {slides[activeIndex].thirdButtonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventSlider